import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AuthErrorBoundary from './components/common/AuthErrorBoundary';
import AppRouter from './components/common/AppRouter';

console.log('App.tsx: Starting application...');

function App() {
  console.log('App.tsx: App component rendering');

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthErrorBoundary>
        <AuthProvider>
          <div className="App">
            <AppRouter />
          </div>
        </AuthProvider>
      </AuthErrorBoundary>
    </Router>
  );
}

export default App;